var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-1 text-bold"},[_vm._v("\n        Columns\n    ")]),_vm._l((_vm.columns),function(column){return _c('RelatedDocColumnSettings',{key:column.key,attrs:{"column":column},on:{"change":_vm.onColumnChange}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }